module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "chap-num"
  }, [_vm._v("Five")]), _vm._v(" "), _c('h3', {
    staticClass: "chap-title"
  }, [_vm._v("Prelude to trouble")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dad was still asleep when we woke up in the morning. His perfume chastened us, and hung densely in the room. The perfume was so appalling that it drove Mum out hawking much earlier than usual.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mum was dressed like a prophetess that morning, as if she were cleansing the day in advance. She wore a white smock, white beads, white kerchief and a fish-patterned wrapper. She made food for us, and left Dad’s breakfast covered on the table. She ate with me, but did not speak. Her face was shadowed as if her spirit were conserving its energies for the trials ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After we had eaten, she got her basins of oranges, mosquito coils and soap. She prayed at the door, and then begged me not to wander far from home. She went out into the early sunlight. I listened as she advertised her wares in a new singing voice. Advertised them to a people who were too poor to buy oil for their lamps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She went down the street, in the direction opposite Madame Koto’s bar. Breaking the settled crust of the sleeping earth with her antiquated sandals. "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("Walking innocently through all the rumours gathering. She was beginning her day as she would end it. Seeking elusive things. Calling out to people who weren’t listening. Soaking in the dust and murmurs of the road.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, Dad was deep in the last decent sleep he would have for a long time. He slept soundly, gathering his secret strengths. While he grew heavier on the bed, our door was wide open for trouble to come and pay us a lengthy visit.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-255604a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/011_Part01Sub01Ch05.vue
// module id = 96
// module chunks = 0